module.exports = __webpack_public_path__ + "static/media/dng-international.9edf90b0.png";